import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { BookOpen, Calendar, MapPin, Users, Clock, ArrowRight, Megaphone } from 'lucide-react';

export default function News() {
  const navigate = useNavigate();

  const newsItems = [
    {
      type: "news",
      title: "Mizaç360, 1000+ Öğrenciye Ulaştı!",
      description: "Platformumuz, Türkiye genelinde 1000'den fazla öğrenciye mizaç analizi hizmeti sundu. Eğitim kurumlarından gelen olumlu geri bildirimler devam ediyor.",
      date: "18 Ocak 2025",
      image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80"
    },
    {
      type: "news",
      title: "Yeni AI Koç Özelliği Yayında!",
      description: "Kullanıcılarımız artık kişiselleştirilmiş AI mizaç koçu ile birebir sohbet edebilir ve kendi mizaç tiplerine özel mentorluk alabilirler.",
      date: "15 Ocak 2025",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      type: "news",
      title: "10 Yeni Okul Mizaç360'a Katıldı",
      description: "İstanbul, Ankara ve İzmir'den 10 eğitim kurumu, öğrenci ve öğretmen gelişimi için Mizaç360 platformunu kullanmaya başladı.",
      date: "12 Ocak 2025",
      image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80"
    }
  ];

  const upcomingEvents = [
    {
      title: "Enneagram ve Eğitim Webinarı",
      description: "İsmail Acarkan ile Enneagram'ın eğitim dünyasında kullanımı üzerine interaktif webinar.",
      date: "25 Ocak 2025",
      time: "14:00 - 16:00",
      location: "Online (Zoom)",
      attendees: "120+ Katılımcı",
      registrationOpen: true
    },
    {
      title: "Öğretmenler için Atölye Çalışması",
      description: "Sınıf içinde mizaç tiplerini kullanarak etkili öğretim stratejileri geliştirme atölyesi.",
      date: "2 Şubat 2025",
      time: "10:00 - 17:00",
      location: "İstanbul - Kadıköy Eğitim Merkezi",
      attendees: "40 Kişi (Sınırlı Kontenjan)",
      registrationOpen: true
    },
    {
      title: "Veliler için Mizaç Tanıtım Semineri",
      description: "Çocuğunuzun mizaç tipini anlama ve ona uygun yaklaşımlar geliştirme semineri.",
      date: "10 Şubat 2025",
      time: "13:00 - 15:00",
      location: "Online (Zoom)",
      attendees: "Sınırsız",
      registrationOpen: true
    },
    {
      title: "Mizaç360 Yıllık Konferansı",
      description: "Eğitim, psikoloji ve teknoloji alanlarından uzmanların katılımıyla yıllık konferans.",
      date: "15 Mart 2025",
      time: "09:00 - 18:00",
      location: "Ankara - Bilkent Otel",
      attendees: "300+ Katılımcı Bekleniyor",
      registrationOpen: false
    }
  ];

  const pastEvents = [
    {
      title: "Mizaç Tipleri ve Öğrenci Başarısı Paneli",
      date: "15 Aralık 2024",
      attendees: "150 Katılımcı",
      summary: "Eğitim uzmanları, mizaç tiplerinin akademik başarıya etkisini tartıştı."
    },
    {
      title: "AI ve Eğitim Geleceği Zirvesi",
      date: "10 Kasım 2024",
      attendees: "200+ Katılımcı",
      summary: "Yapay zekanın eğitimde kişiselleştirme konusundaki rolü ele alındı."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      {/* Header */}
      <header className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-emerald-600 rounded-xl flex items-center justify-center cursor-pointer" onClick={() => navigate('/')}>
              <BookOpen className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-xl font-bold text-slate-800 cursor-pointer" onClick={() => navigate('/')}>Mizaç360</h1>
          </div>
          <div className="flex items-center gap-6">
            <a href="/resources" className="text-slate-600 hover:text-blue-600 transition">Kaynaklar</a>
            <a href="/blog" className="text-slate-600 hover:text-blue-600 transition">Blog</a>
            <a href="/news" className="text-slate-700 hover:text-blue-600 font-medium transition">Haberler & Etkinlikler</a>
            <a href="/about" className="text-slate-600 hover:text-blue-600 transition">Hakkımızda</a>
            <Button variant="outline" onClick={() => navigate('/')}>Ana Sayfa</Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-emerald-100 text-emerald-700">Güncel Gelişmeler</Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Haberler & Etkinlikler
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Mizaç360 platformundaki son gelişmeler ve yaklaşan eğitim etkinlikleri
          </p>
        </div>

        {/* Latest News */}
        <section className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
              <Megaphone className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-slate-800">Son Haberler</h3>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {newsItems.map((news, idx) => (
              <Card key={idx} className="shadow-lg border-none hover:shadow-xl transition-shadow overflow-hidden group cursor-pointer">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={news.image} 
                    alt={news.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <CardHeader>
                  <div className="flex items-center gap-2 text-sm text-slate-500 mb-2">
                    <Calendar className="w-4 h-4" />
                    <span>{news.date}</span>
                  </div>
                  <CardTitle className="text-lg leading-tight">{news.title}</CardTitle>
                  <CardDescription className="text-sm mt-2">{news.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <Button variant="ghost" size="sm" className="group/btn p-0 h-auto">
                    Detayları Gör
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* Upcoming Events */}
        <section className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center">
              <Calendar className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-slate-800">Yaklaşan Etkinlikler</h3>
          </div>

          <div className="space-y-6">
            {upcomingEvents.map((event, idx) => (
              <Card key={idx} className="shadow-lg border-none hover:shadow-xl transition-shadow">
                <CardHeader>
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <CardTitle className="text-xl mb-2">{event.title}</CardTitle>
                      <CardDescription className="text-base">{event.description}</CardDescription>
                    </div>
                    {event.registrationOpen && (
                      <Badge className="bg-green-100 text-green-700">Kayıt Açık</Badge>
                    )}
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid md:grid-cols-4 gap-4 mb-4">
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <Calendar className="w-4 h-4 text-blue-600" />
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <Clock className="w-4 h-4 text-emerald-600" />
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <MapPin className="w-4 h-4 text-purple-600" />
                      <span>{event.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <Users className="w-4 h-4 text-amber-600" />
                      <span>{event.attendees}</span>
                    </div>
                  </div>
                  {event.registrationOpen && (
                    <Button className="bg-gradient-to-r from-blue-600 to-emerald-600">
                      Kayıt Ol
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* Past Events */}
        <section>
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-slate-400 to-slate-500 rounded-xl flex items-center justify-center">
              <Calendar className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-slate-800">Geçmiş Etkinlikler</h3>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {pastEvents.map((event, idx) => (
              <Card key={idx} className="shadow-lg border-none">
                <CardHeader>
                  <CardTitle className="text-lg">{event.title}</CardTitle>
                  <CardDescription>
                    <div className="flex items-center gap-4 text-sm mt-2">
                      <div className="flex items-center gap-1">
                        <Calendar className="w-4 h-4" />
                        <span>{event.date}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        <span>{event.attendees}</span>
                      </div>
                    </div>
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-600 text-sm">{event.summary}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-8 mt-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-slate-300">© 2025 Mizaç360. Tüm hakları saklıdır.</p>
          <p className="text-sm text-slate-400 mt-2">
            Bilimsel kaynaklar: İsmail Acarkan, Ziya Selçuk, Eduen.com.tr, The Enneagram Institute, Integrative9
          </p>
        </div>
      </footer>
    </div>
  );
}
